/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagPagedData } from '../../models/tag-paged-data';

export interface GetTags$Params {
  PageNumber?: number;
  PageSize?: number;
}

export function getTags(http: HttpClient, rootUrl: string, params?: GetTags$Params, context?: HttpContext): Observable<StrictHttpResponse<TagPagedData>> {
  const rb = new RequestBuilder(rootUrl, getTags.PATH, 'get');
  if (params) {
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagPagedData>;
    })
  );
}

getTags.PATH = '/tag';
